import { result } from 'lodash-es';
import moment from 'moment';

import { jsonResponseHandling } from '../fetch';
import { BLOCKS_SERVICE_DATE_FORMAT } from '../control/blocks';
import { getViewPermission } from '../helpers';
import { fetchWithAuthHeader } from '../../auth';
import { apiUrl, BLOCK_MANAGEMENT_PATH, BLOCK_MANAGEMENT_CLIENT_PATH } from '../api-manager';

export const getBlocksViewPermission = () => getViewPermission(apiUrl(`${BLOCK_MANAGEMENT_PATH}/view`));

export const getOperationalBlockRuns = ({ blockId, serviceDate } = {}) => {
    const blockIdParam = blockId ? `operationalBlockId=${blockId}&` : '';
    const date = serviceDate || moment().format(BLOCKS_SERVICE_DATE_FORMAT);
    const serviceDateParam = `serviceDate=${date}`;
    return fetchWithAuthHeader(apiUrl(`${BLOCK_MANAGEMENT_PATH}/block-runs?${blockIdParam}${serviceDateParam}`), { method: 'GET' })
        .then(response => jsonResponseHandling(response));
};

export const getOrphanOperationalTripRuns = async ({ serviceDate }) => {
    const filterParam = 'filter=orphan&';
    const date = serviceDate || moment().format(BLOCKS_SERVICE_DATE_FORMAT);
    const serviceDateParam = `serviceDate=${date}`;

    const response = await fetchWithAuthHeader(apiUrl(`${BLOCK_MANAGEMENT_PATH}/trip-runs?${filterParam}${serviceDateParam}`), { method: 'GET' });
    const json = await jsonResponseHandling(response);
    return json;
};

export const allocateVehicles = (blockId, payload) => {
    const url = apiUrl(`${BLOCK_MANAGEMENT_PATH}/block-runs/${blockId}`);
    return fetchWithAuthHeader(
        url,
        {
            method: 'PATCH',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload),
        },
    ).then(response => jsonResponseHandling(response));
};

export const addOperationalBlockRun = (operationalBlockRun) => {
    const url = apiUrl(`${BLOCK_MANAGEMENT_PATH}/block-runs/`);
    return fetchWithAuthHeader(
        url,
        {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(operationalBlockRun),
        },
    ).then(response => jsonResponseHandling(response));
};

export const moveOperationalTrips = (payload) => {
    const url = apiUrl(`${BLOCK_MANAGEMENT_PATH}/block-runs/`);
    return fetchWithAuthHeader(
        url,
        {
            method: 'PATCH',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload),
        },
    ).then(response => jsonResponseHandling(response));
};

export const getAllocationSnapshot = () => fetchWithAuthHeader(apiUrl(`${BLOCK_MANAGEMENT_CLIENT_PATH}/allocations/`), { method: 'GET' })
    .then(response => jsonResponseHandling(response))
    .then(data => result(data, 'all', []));
